import {OETarget} from '../../../react-oe/oe-target';

export const OEXRayIcarusCustomPropKey = {
    mode:                                   'xray_mode',
    itemId:                                 'xray_item_id',
    animateCamera:                          'xray_animate_camera',
    vpFrame:                                'xray_vp_frame'
};

export const OEXRayIcarusTargetType = {
    patient:                                'patient',
    xRay:                                   'xRay',
    anatomy:                                'anatomy'
};

export const OEXRayIcarusMode = {
    uninitialized:                          0,
    std:                                    1,
    xRay:                                   2,
    stringArray: ['uninitialized', 'std', 'xRay'],
    modeToString(mode)  {
        return this.stringArray[Math.min(Math.max(mode, 0), this.stringArray.length - 1)];
    }
};

export class OEXRayIcarusId  {

    constructor(item = '', sub = '')   {
        if(!item)   {
            this.item = '';
            this.sub = '';
            return;
        }

        if(typeof(item) === 'object')   {
            this.item = item.item ? item.item : '';
            this.sub = item.sub ? item.sub : '';
            return;
        }

        this.item = item;
        this.sub = sub;
    }

    isNull()    {
        return !this.item.length;
    }

    hasSub()    {
        return this.item.length && this.sub.length;
    }

    withoutSub()    {
        return new OEXRayIcarusId(this.item);
    }
}

OEXRayIcarusId.isEqual = function(u, v)  {
    (u.isNull() && v.isNull()) || (u.item == v.item && u.sub == v.sub);
}

export class OEXRayIcarusModel   {

    constructor(data)   {
        this.data = data;
    }

    setData(data)   {
        this.data = data;
    }

    getItem(id)   {
        if(!this.data || !this.data.items || this.isNull(id)) return;
        return this.data.items[id.item];
    }

    getSubItem(id)   {
        if(this.isNull(id) || !this.hasSub(id)) return;
        let item = this.getItem(id);
        if(!item || !item.subItems) return;
        return item.subItems[id.sub];
    }

    getProperItem(id)   {
        return this.hasSub(id) ? this.getSubItem(id) : this.getItem(id);
    }

    getResolvedItem(id) {
        let subItem = this.getSubItem(id);
        if(!subItem)    return this.getItem(id);
        let item = this.getItem(id);
        if(!item)   return;

        let ret = {
            target: item.target,
            xRayImage: item.xRayImage,
            textSrc: item.textSrc,
            xRayTextSrc: item.xRayTextSrc
        };

        if(subItem.target)      ret.target = subItem.target;
        if(subItem.xRayImage)   ret.xRayImage = subItem.xRayImage;
        if(subItem.textSrc)     ret.textSrc = subItem.textSrc;
        if(subItem.xRayTextSrc) ret.xRayTextSrc = subItem.xRayTextSrc;

        return ret;
    }

    isIdle(id) {
        return !this.isNull(id) && !id.sub.length && this.data && this.data.idleId === id.item;
    }

    isNull(id) {
        return !id || id.isNull();
    }

    isIdleOrNull(id)   {
        return this.isIdle(id) || this.isNull(id);
    }

    hasSub(id)  {
        return !this.isNull(id) && id.sub.length;
    }

    getTarget()  {
        return this.data ? this.data.target : undefined;
    }

    getItemTarget(id)  {
        if(this.isNull(id)) return undefined;
        const item = this.getResolvedItem(id);
        return item ? item.target : undefined;
    }

    getXRayImage(id)  {
        const item = this.getResolvedItem(id);
        return item ? item.xRayImage : undefined;
    }

    getItemForTarget(target, id)    {
        if(!this.isIdleOrNull(id) && this.getItemTarget(id) === target)   return id;
        return target && this.data && this.data.targets && this.data.targets[target] ? this.data.targets[target].itemId : undefined;
    }
}

OEXRayIcarusModel.shared = function()   {
    if(!OEXRayIcarusModel._sharedInstance)   OEXRayIcarusModel._sharedInstance = new OEXRayIcarusModel();
    return OEXRayIcarusModel._sharedInstance;
};

OEXRayIcarusModel.stdData = function()   {
    let ret = {
        idleId: 'sitting',
        items: {
            patient: {
                target: OETarget.humanThighKnee,
                xRayImage: undefined
            },
            kneeJointVM: {
                target: OETarget.humanThighKnee,
                xRayImage: '01_Knie_stehend_ap.png',
                textSrc: '25_Knie_AP_stehend.html',
                xRayTextSrc: 'xRay/25R_Knie_AP_stehend.html'
            },
            kneeJointAP: {
                target: OETarget.humanThighKnee,
                xRayImage: '02_Knie_liegend_ap.png',
                textSrc: '01_Knie_AP.html',
                xRayTextSrc: 'xRay/01R_Knie_AP.html',
                subItems: {
                    kneeJointAP_F1: {
                        xRayImage: 'Knie_ap_Fehl_01.png',
                    },
                    kneeJointAP_F2: {
                        xRayImage: 'Knie_ap_Fehl_02.png',
                    }
                }
            },
            kneeJointLL: {
                target: OETarget.humanThighKnee,
                xRayImage: '03_Knie_liegend_lat.png',
                textSrc: '15_Knie_LL.html',
                xRayTextSrc: 'xRay/15R_Knie_LL.html'
            },
            ankleJointAP: {
                target: OETarget.humanAnkleFoot,
                xRayImage: '04_Sprunggelenk_ap.png',
                textSrc: '02_Sprunggelenk_AP.html',
                xRayTextSrc: 'xRay/02R_Sprunggelenk_AP.html',
                subItems: {
                    ankleJointAP_F1: {
                        xRayImage: 'Sprunggelenk_ap_Fehl_01.png',
                    },
                    ankleJointAP_F2: {
                        xRayImage: 'Sprunggelenk_ap_Fehl_02.png',
                    }
                }
            },
            neckSpineAP: {
                target: OETarget.humanNeckBack,
                xRayImage: '05_HWS_stehend_ap.png',
                textSrc: '03_HWS_AP_stehend.html',
                xRayTextSrc: 'xRay/03R_HWS_AP_stehend.html'
            },
            neckSpineAP2: {
                target: OETarget.humanNeckBack,
                xRayImage: '06_HWS_sitzend_ap.png',
                textSrc: '04_HWS_AP_sitzend.html',
                xRayTextSrc: 'xRay/04R_HWS_AP_sitzend.html'
            },
            neckSpineLL: {
                target: OETarget.humanNeckBack,
                xRayImage: '07_HWS_sitzend_lat.png',
                textSrc: '05_HWS_LL.html',
                xRayTextSrc: 'xRay/05R_HWS_LL.html'
            },
            chestSpineLL: {
                target: OETarget.humanShoulderGirdle,
                xRayImage: '06_BWS_lat.png',
                textSrc: '06_BWS_LL_Arme_oben.html',
                xRayTextSrc: 'xRay/06R_BWS_LL_Arme_oben.html'
            },
            chestSpineAP: {
                target: OETarget.humanShoulderGirdle,
                xRayImage: '08_BWS_stehend_ap.png',
                textSrc: '07_BWS_AP.html',
                xRayTextSrc: 'xRay/07R_BWS_AP.html'
            },
            chestSpineLL2: {
                target: OETarget.humanShoulderGirdle,
                xRayImage: '09_BWS_stehend_lat.png',
                textSrc: '08_BWS_LL_Arme_vorn.html',
                xRayTextSrc: 'xRay/08R_BWS_LL_Arme_vorn.html'
            },
            lumbarSpineAP: {
                target: OETarget.humanHip2,
                xRayImage: '10_LWS_liegend_ap.png',
                textSrc: '09_LWS_AP.html',
                xRayTextSrc: 'xRay/09R_LWS_AP.html'
            },
            lumbarSpineLL: {
                target: OETarget.humanHip2,
                xRayImage: '10_LWS_lat.png',
                textSrc: '10_LWS_LL.html',
                xRayTextSrc: 'xRay/10R_LWS_LL.html'
            },
            lumbarSpineLL2: {
                target: OETarget.humanHip2,
                xRayImage: '11_LWS_liegend_lat.png',
                textSrc: '10_LWS_LL.html',
                xRayTextSrc: 'xRay/10R_LWS_LL.html'
            },
            hipJointAP: {
                target: OETarget.humanHip2,
                xRayImage: '12_Huefte_liegend_ap.png',
                textSrc: '11_Hüfte_AP.html',
                xRayTextSrc: 'xRay/11R_Hüfte_AP.html'
            },
            hipJointAP2: {
                target: OETarget.humanHip2,
                xRayImage: '13_Becken_stehend_ap.png',
                textSrc: '12_Becken_AP.html',
                xRayTextSrc: 'xRay/12R_Becken_AP.html'
            },
            shoulderJointVM: {
                target: OETarget.humanShoulderGirdle,
                xRayImage: '14_Schulter_sitzend_vm.png',
                textSrc: '13_Schulter_axial_sitzend.html',
                xRayTextSrc: 'xRay/13R_Schulter_axial_sitzend.html'
            },
            shoulderJointAP: {
                target: OETarget.humanShoulderGirdle,
                xRayImage: '15_Schulter_stehend_ap.png',
                textSrc: '14_Schulter_AP.html',
                xRayTextSrc: 'xRay/14R_Schulter_AP.html'
            },
            sitting: {
                target: OETarget.humanThighKnee,
                xRayImage: undefined
            },
            elbowAP: {
                target: OETarget.humanArm,
                xRayImage: '16_Ellenbogen_sitzend_ap.png',
                textSrc: '19_Ellenbogen_AP.html',
                xRayTextSrc: 'xRay/19R_Ellenbogen_AP.html'
            },
            elbowLAT: {
                target: OETarget.humanArm,
                xRayImage: '17_Ellenbogen_sitzend_lat.png',
                textSrc: '18_Ellenbogen_LAT.html',
                xRayTextSrc: 'xRay/18R_Ellenbogen_LAT.html'
            },
            thoraxAP: {
                target: OETarget.humanTrunk,
                xRayImage: '18_Thorax_stehend_ap.png',
                textSrc: '20_Thorax_AP.html',
                xRayTextSrc: 'xRay/20R_Thorax_AP.html'
            },
            thoraxLAT: {
                target: OETarget.humanTrunk,
                xRayImage: '19_Thorax_stehend_lat.png',
                textSrc: '21_Thorax_LAT.html',
                xRayTextSrc: 'xRay/21R_Thorax_LAT.html'
            },
            abdomenPA: {
                target: OETarget.humanTrunk,
                xRayImage: '20_Abdomen_stehend_pa.png',
                textSrc: '22_Abdomen_stehend.html',
                xRayTextSrc: 'xRay/22R_Abdomen_stehend.html'
            },
            wristAP: {
                target: OETarget.humanArm,
                xRayImage: '21_Handgelenk_sitzend_ap.png',
                textSrc: '23_Handgelenk_AP.html',
                xRayTextSrc: 'xRay/23R_Handgelenk_AP.html'
            },
            wristLAT: {
                target: OETarget.humanArm,
                xRayImage: '22_Handgelenk_sitzend_lat.png',
                textSrc: '24_Handgelenk_LAT.html',
                xRayTextSrc: 'xRay/24R_Handgelenk_LAT.html'
            },
            wristNav: {
                target: OETarget.humanArm,
                xRayImage: undefined
            }
        },
        target: OETarget.xRayIcarus,
        targets: {}
    }

    ret.targets[OETarget.humanThighKnee]        = {itemId: new OEXRayIcarusId('kneeJointVM')};
    ret.targets[OETarget.humanAnkleFoot]        = {itemId: new OEXRayIcarusId('ankleJointAP')};
    ret.targets[OETarget.humanNeckBack]         = {itemId: new OEXRayIcarusId('neckSpineAP')};
    ret.targets[OETarget.humanShoulderGirdle]   = {itemId: new OEXRayIcarusId('chestSpineAP')};
    ret.targets[OETarget.humanHip2]             = {itemId: new OEXRayIcarusId('hipJointAP')};
    ret.targets[OETarget.humanArm]              = {itemId: new OEXRayIcarusId('elbowAP')};
    ret.targets[OETarget.humanTrunk]            = {itemId: new OEXRayIcarusId('thoraxAP')};

    return ret;
};

export const OEXRayIcarusOverlayNotifications = {
    cameraResetBtnPressed:                      'xray_camera_reset_btn_pressed'
};